/** localStorage key for preview data (PerformerProfileDto format). */
export const PERFORMERS_PREVIEW_STORAGE_KEY = 'performers-preview-data';
